export default {
  path: "/symptom-checker",
  name: process.env.VUE_APP_SYMPTOM_CHECKER_LAYOUT,
  redirect: "/symptom-checker/init",
  component: () => import("@/pages/symptom-checker/index.vue"),
  meta: {
    guest: true,
  },
  children: [
    {
      path: "/symptom-checker/begin",
      name: process.env.VUE_APP_SYMPTOM_CHECKER_BEGIN,
      component: () => import("@/pages/symptom-checker/Begin.vue"),
      meta: {
        guest: true,
      },
      beforeEnter: async (to, from, next) => {
        console.log("Router-SC-index-beforeEnter")
        const store = await import("@/store/index")
        const q = store.default.getters["sc/question"]
        console.info("WHAT IS THE Questions here", q)
        if (q === undefined || q === null) {
          // make sure that we have a valid question setup
          console.log("ensure loaded questions")
          const sessionId = JSON.parse(localStorage.getItem("store")).sc.session_id;
          if (!sessionId){
            console.info("Router: NO session ID!")
            next();
          }
          next({ name: process.env.VUE_APP_SYMPTOM_CHECKER_BEGIN })
        } else {
          next()
        }
      },
    },
    {
      path: "/symptom-checker/next",
      name: process.env.VUE_APP_SYMPTOM_CHECKER_NEXT,
      component: () => import("@/pages/symptom-checker/Next.vue"),
      meta: {
        requiresSessionId: true,
        guest: true,
      },
    },
    {
      path: "/symptom-checker/terminate",
      name: process.env.VUE_APP_SYMPTOM_CHECKER_TERMINATE,
      component: () => import("@/pages/symptom-checker/Terminate.vue"),
      meta: {
        guest: true,
      },
    },
    {
      path: "/symptom-checker/pre-summary",
      name: process.env.VUE_APP_DASHBOARD_PRE_SUMMARY,
      component: () => import("@/pages/dashboard/Pre-Summary.vue"),
      meta: {
        guest: true,
      },
    },
    {
      path: "/symptom-checker/summary",
      name: process.env.VUE_APP_SYMPTOM_CHECKER_SUMMARY,
      component: () => import("@/pages/symptom-checker/Summary.vue"),
      meta: {
        guest: true,
      },
    },
  ],
}
